<template>
  <div class="material_progress">
    <van-sticky>
      <van-nav-bar title="资料审核" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-steps
      class="progress_steps"
      :active="active"
      active-color="#20C8ED"
      inactive-color="#000"
    >
      <van-step>已提交</van-step>
      <van-step>资料审核中</van-step>
      <van-step>已完成</van-step>
    </van-steps>

    <div class="progress_data">
      <div>
        姓名：<span>{{ placeInfo.contactName }}</span>
      </div>
      <div>
        联系电话：<span>{{ placeInfo.contactNumber }}</span>
      </div>
      <div>
        所在地区：<span>{{
          placeInfo.province + placeInfo.city + placeInfo.district
        }}</span>
      </div>
      <div>
        场地类型：<span>{{ placeInfo.type_name }}</span>
      </div>
      <div v-if="placeInfo.remark">
        备注：<span>{{ placeInfo.remark }}</span>
      </div>
    </div>

    <van-button plain type="primary" block @click="goToIndex()">返回首页</van-button>
  </div>
</template>

<script>
import { Button, NavBar, Step, Steps } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
  data() {
    return {
      active: 1,
      placeInfo: [],
      gobackPath: "",
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.gobackPath = from.path;
    });
  },

  //初始化加载
  created() {
    //申请场地-入驻申请-查看
    this.siteSupplierApplyDetailAPI();
  },

  methods: {
    //返回上一页
    goback() {
      if (this.gobackPath === "/personal/index" || this.gobackPath === "/") {
        this.$router.go(-1);
      } else {
        this.$router.go(-2);
      }
    },

    //返回首页
    goToIndex() {
       this.$router.push({ path: "/" });
    },

    //申请场地-入驻申请-查看
    siteSupplierApplyDetailAPI() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            if (res.data.data.applyStatus != 3) {
              that.active = res.data.data.applyStatus;
              that.placeInfo = res.data.data;
            } else {
              console.log("审核未通过");
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.material_progress {
  .van-button {
    margin: 50px auto;
    width: 80%;
  }

  .progress_steps {
    border-top: 5px solid #f5f4f5;
    border-bottom: 5px solid #f5f4f5;
    padding: 30px 20px;
  }

  .progress_data {
    padding: 15px;
    font-size: 12px;

    div {
      display: flex;
      margin-bottom: 15px;

      span {
        color: #999;
        width: 80%;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/personal/materialProgress.vue